function mergeLocationSearchStrings(searchStr1: string | undefined, searchStr2: string | undefined) {
    const searchParams1 = new URLSearchParams(searchStr1);
    const searchParams2 = new URLSearchParams(searchStr2);
    searchParams2.forEach((value, key) => {
        searchParams1.set(key, value);
    });
    return searchParams1.toString();
}

export default mergeLocationSearchStrings;
